import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { Table } from '../../../../components/general/table';
import {
    SURVEYS,
    SURVEYS_NEW,
    SURVEYS_EDIT,
    SURVEYS_DETAIL,
} from '../../../../../routes/paths';
import { asyncGetSurveyLogs } from '../../../../../services/survey.service';
import { useSurveyLogs } from './hook';
import { SurveyLogsProps } from './props';

export const SurveyLogs = ({
    historical: historicalProp,
    showHistorical,
}: SurveyLogsProps = {}) => {
    const { id } = useParams();
    const [historical, setHistorical] = useState<any[]>(historicalProp || []);
    const [loading, setLoading] = useState(!historicalProp);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    // Si se pasa historical como prop, usarlo directamente (modo embebido)
    const isEmbedded = showHistorical !== undefined;
    const dataToUse = isEmbedded ? historicalProp || [] : historical;

    const { columns, rows } = useSurveyLogs({ historical: dataToUse });

    useEffect(() => {
        // Solo cargar logs si no está en modo embebido y hay un id
        if (!isEmbedded && id) {
            loadLogs();
        }
    }, [id, isEmbedded]);

    useEffect(() => {
        // Actualizar historical cuando cambia el prop
        if (isEmbedded && historicalProp) {
            setHistorical(historicalProp);
        }
    }, [historicalProp, isEmbedded]);

    const loadLogs = async () => {
        setLoading(true);
        try {
            const data = await asyncGetSurveyLogs(id!);
            setHistorical(data);
        } catch (error) {
            console.error('Error loading logs:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePaginationChange = (newPagination: {
        page: number;
        pageSize: number;
    }) => {
        setPaginationModel(newPagination);
    };

    const paginatedRows = rows.slice(
        paginationModel.page * paginationModel.pageSize,
        (paginationModel.page + 1) * paginationModel.pageSize
    );

    // Si está en modo embebido, solo mostrar la tabla
    if (isEmbedded) {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Table
                        columns={columns}
                        rows={paginatedRows}
                        rowCount={rows.length}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handlePaginationChange}
                        pageSizeOptions={[10, 20, 50]}
                        disableRowSelectionOnClick
                    />
                </Grid>
            </Grid>
        );
    }

    // Modo página completa
    return (
        <>
            <FormView
                title="Historial de Cambios"
                additionalButtons={
                    <ActionButtonGroup
                        id={id || ''}
                        buttonCreate={{
                            show: true,
                            route: SURVEYS_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SURVEYS,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: SURVEYS_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SURVEYS_DETAIL,
                        }}
                        buttonLog={{
                            show: false,
                        }}
                    />
                }
            />
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12}>
                    {loading ? (
                        <div>Cargando historial...</div>
                    ) : (
                        <Table
                            columns={columns}
                            rows={paginatedRows}
                            rowCount={rows.length}
                            paginationModel={paginationModel}
                            onPaginationModelChange={handlePaginationChange}
                            pageSizeOptions={[10, 20, 50]}
                            disableRowSelectionOnClick
                        />
                    )}
                </Grid>
            </Grid>
        </>
    );
};
